import React from "react";
import { Form } from "antd";
import Input from "./BaseInput";
import AutoDismissToolTip from "@/components/AutoDismissToolTip";

const WaybillNoField: React.FC = () => {
    return (
        <AutoDismissToolTip
            placement="top"
            title={
                <p>
                    1、运单号最多可同时搜索200个
                    <br />
                    2、运单号支持完整单号或者单号后四位搜索，子母单则搜索母单号
                    <br />
                    3、多个运单号可用逗号、换行、空格分隔
                    <br />
                </p>
            }
            trigger="click"
        >
            <Form.Item name="waybillNo" label={<span className="search-field-label">运单号</span>}>
                <Input allowClear />
            </Form.Item>
        </AutoDismissToolTip>
    );
};

export default React.memo(WaybillNoField);
